import styled from 'styled-components'

export const SecuritySettingItem = styled.div`
  padding: 1.5rem;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background-color: #f8f9fa;
  margin-bottom: 1rem;
  transition: all 0.2s ease;

  &:hover {
    border-color: #007bff;
    box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
  }

  h5 {
    color: #212529;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  p {
    color: #6c757d;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
  }

  .badge {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
  }

  .bg-success {
    background-color: #28a745 !important;
  }

  .bg-secondary {
    background-color: #6c757d !important;
  }
`

export const SecuritySettingsContainer = styled.div`
  .security-setting-item {
    padding: 1.5rem;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    background-color: #f8f9fa;
    margin-bottom: 1rem;
    transition: all 0.2s ease;

    &:hover {
      border-color: #007bff;
      box-shadow: 0 2px 4px rgba(0, 123, 255, 0.1);
    }

    h5 {
      color: #212529;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }

    p {
      color: #6c757d;
      font-size: 0.9rem;
      margin-bottom: 0.5rem;
    }

    .badge {
      font-size: 0.75rem;
      padding: 0.25rem 0.5rem;
    }

    .bg-success {
      background-color: #28a745 !important;
    }

    .bg-secondary {
      background-color: #6c757d !important;
    }
  }

  .custom-toggle {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;

    .toggle-input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .toggle-label {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      transition: 0.4s;
      border-radius: 34px;

      &:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        transition: 0.4s;
        border-radius: 50%;
      }
    }

    .toggle-input:checked + .toggle-label {
      background-color: #007bff;
    }

    .toggle-input:checked + .toggle-label:before {
      transform: translateX(26px);
    }

    .toggle-input:disabled + .toggle-label {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`
